module.exports = __webpack_public_path__ + "static/media/boardOfDirectors.89cc405d.png";